var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"App",class:{'short': _vm.isShortPage},attrs:{"id":"app"}},[_c('core-header'),_c('main',{staticClass:"Content"},[_c('transition',{attrs:{"name":"fade","mode":"out-in"}},[_c('router-view')],1)],1),_c('core-footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }